import { PageContent } from 'components/page';
import { HomeBannerImage, HomeGuestCourses, HomeGuestHeader } from '.';

const HomeGuest = () => {
  return (
    <div>
      <HomeBannerImage />
      <HomeGuestHeader />

      <PageContent>
        <HomeGuestCourses />
      </PageContent>
    </div>
  );
};

export default HomeGuest;
